
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 56 41","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55.369 7.125a1.029 1.029 0 00-1.104.178L29.516 29.567l-9.722-7.75a1.043 1.043 0 00-1.34.039L.33 38.44a1.03 1.03 0 00-.256 1.144c.158.395.532.651.966.651h53.935c.571 0 1.025-.453 1.025-1.025V8.072c-.02-.414-.256-.79-.631-.947zm-1.44 31.06H3.683l15.52-14.2 9.721 7.75c.395.316.967.297 1.341-.039L53.93 10.4v27.785z"}}),_c('path',{attrs:{"d":"M5.378 21.738a.988.988 0 00.67-.256l11.537-10.057 9.722 7.77c.394.315.966.295 1.34-.04L44.425 4.957l-1.598 5.935c-.138.552.178 1.124.73 1.262.099.02.177.04.276.04.453 0 .868-.296 1.006-.77l2.721-10.116c.099-.355 0-.73-.276-1.005a1.103 1.103 0 00-1.006-.276l-10.116 2.72c-.552.139-.868.71-.73 1.263.138.552.71.887 1.262.73l6.962-1.874-15.737 14.16-9.722-7.77a1.017 1.017 0 00-1.321.039L4.688 19.944a1.032 1.032 0 00-.099 1.459c.217.217.493.335.789.335zM43.025 29.055c.256 0 .532-.099.73-.296l5.107-5.107a1.048 1.048 0 000-1.46 1.048 1.048 0 00-1.46 0L42.295 27.3a1.048 1.048 0 000 1.46c.217.196.473.295.73.295zM18.985 29.153l-5.107 5.108a1.048 1.048 0 000 1.459 1.046 1.046 0 001.46 0l5.107-5.107a1.048 1.048 0 000-1.46c-.395-.394-1.046-.394-1.46 0z"}})])
          )
        }
      }
    